import "@paperclip-labs/whisk-sdk/styles.css";
import "@farcaster/auth-kit/styles.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./sentry.ts";
import * as Sentry from "@sentry/react";

async function enableMocking() {
  if (process.env.NODE_ENV === "production" || import.meta.env.VITE_MSW != "true") {
    return;
  }

  const { worker } = await import("./mocks/browser.ts");

  return worker.start({ onUnhandledRequest: "bypass" });
}

// Google Tag Manager setup
const googleTagManagerId = import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID;

if (googleTagManagerId) {
  // Inject <noscript> fallback
  const noscript = document.createElement("noscript");
  noscript.innerHTML = `
    <iframe src="https://www.googletagmanager.com/ns.html?id=${googleTagManagerId}"
            height="0" width="0" style="display:none;visibility:hidden"></iframe>
  `;
  document.body.appendChild(noscript);
}

enableMocking().then(() => {
  createRoot(document.getElementById("root")!, {
    onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
      console.warn("Uncaught error", error, errorInfo.componentStack);
    }),
    onCaughtError: (error, errorInfo) => {
      console.error(error, errorInfo);
      Sentry.reactErrorHandler();
    },
    onRecoverableError: (error, errorInfo) => {
      console.error(error, errorInfo);
      Sentry.reactErrorHandler();
    },
  }).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
